import { useIsFetching, useQueryClient } from 'react-query';
import { createQueryData } from '../helpers/createQueryData';
import { useInvalidate } from '../helpers/useInvalidate';
import { useEvent } from '../../../../hooks/useEvent';

let key;
const endPoint = 'Acceptance/acceptance_view_flats';

const { useQuery, createKey } = createQueryData({ endPoint });

const useAcceptanceViewFlatsQuery = ({
  params: { acceptanceId, houseId } = {},
  options,
}) => {
  key = createKey({ acceptanceId, houseId });

  return useQuery({
    params: { acceptanceId, houseId },
    options: {
      enabled: Boolean(acceptanceId),
      staleTime: 1000 * 5,
      ...options,
    },
  });
};

const useAcceptanceViewFlatsInvalidate = () => useInvalidate([endPoint]);

const useAcceptanceViewFlatsSyncUpdate = () => {
  const queryClient = useQueryClient();
  return useEvent((updater) => queryClient.setQueryData(key, updater));
};

const useAcceptanceViewFlatsIsFetching = () => useIsFetching([endPoint]);

export {
  useAcceptanceViewFlatsQuery,
  useAcceptanceViewFlatsInvalidate,
  useAcceptanceViewFlatsSyncUpdate,
  useAcceptanceViewFlatsIsFetching,
};
